
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import AddDoctor from "./AddDoctor";

const CURDDoctor = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <AddDoctor />
      </div>
    </div>
  );
};

export default CURDDoctor;
